import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useBreadcrumbs } from '../hooks';
import { Header, Table, Groupper, Input, Button } from 'react-frontier';
import { Link } from 'react-router-dom';
import { UserClass } from '../SiteClasses';

import moment from 'moment';
import API from '../API';

interface UsersListProps{
	
}

var Users = (props: UsersListProps)=>{
	var { t } = useTranslation();
	var { setTitle } = useBreadcrumbs();
	var [loadError, setLoadError] = useState<string>(null);
	var [users, setUsers] = useState<UserClass []>(null);
	var [filter, setFilter] = useState<string>('');
	var [searchUsers, setSearchUsers] = useState<UserClass[]>(null);
	var [searchTimeout, setSearchTimeout] = useState<any>(null);
	var [searching, setSearching] = useState<boolean>(false);

	useEffect(()=>{
		setTitle('Usuarios');
		API.getUsers().then(res=>{
			if(res.error) return setLoadError(res.message);
			setUsers(res.data);
		}).catch(err=>{
			setLoadError('Hubo un error cargando la lista de usuarios (LCL-1)');
		})
	}, []);

	var onSearchChange = (val: string)=>{
		setFilter(val);
		if(searchTimeout) clearTimeout(searchTimeout);
		if(val.length<3){
			return setSearchUsers(null);
		}
		setSearchTimeout(setTimeout(()=>{
			search(val)
		}, 500));
	}

	var search = (query: string)=>{
		setSearching(true);
		setSearchUsers(null);
		API.searchUsers(query).then(res=>{
			if (res.error) return setLoadError(res.message);
			setSearchUsers(res.data);
		}).catch(err=>{
			return setLoadError('Hubo un error al buscar el usuario. (SUS-1)');
		}).finally(()=>{
			setSearching(false);
		})
	}
	
	if(loadError) { return <Header text='Error' subtext={loadError} />};
	if(!users) { return <Header text='Cargando datos' loading/> };

	var shown_users = searchUsers || users;

	return <div>
		<Groupper title={'Usuarios'} width={800} style={{ marginTop: 20 }}>
			<Input placeholder='Buscar...' value={filter} onChange={onSearchChange} />
			<Table striped fitted selectable
				headers={['ID','Nombre', 'Apellido', 'Email', 'Creación']}
				className='first last'
				style={{ marginTop: 20 }}
			>
				{searching ? (
					<Table.Cell row className='empty' colSpan={5}>
						<Header loading text='Cargando datos' />
					</Table.Cell>
				) : (
					shown_users.length !== 0 ? (
						shown_users.map(u => (
							<Table.Row
								collapsingIndexes={[0, 1, 2, 4]}
								compact
								key={u.user_id}
								as={Link}
								to={`/users/${u.user_id}`}
								data={[
									u.user_id,
									u.first_name,
									u.last_name,
									u.email,
									moment.unix(u.date_created).format('DD/MM/YY HH:mm')
								]}
							/>
						))
					) : (
						<Table.Cell row className='empty' colSpan={5}>
							No se encontraron registros
						</Table.Cell>
					)
				)}
			</Table>
		</Groupper>
	</div>
}

export default Users;